<template>
  <div>
    <main-layout>
      <v-container style="max-width: 1000px">
        <v-layout>
          <v-flex>
            <h3 class="headline" style="display: inline">{{ $t('Welcome Message') }}</h3>
            <p>{{ $t('First greeting message to your customers (Not exceed 20 alphabets)') }}</p>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn
              fab
              outline
              small
              color="primary"
              v-if="!isEditWelcomeType"
              @click="isEditWelcomeType = !isEditWelcomeType"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <template v-if="!isEditWelcomeType">
          <v-card v-if="currentWelcomeOption">
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm3 md4 class="text-xs-center">
                  <img :src="currentWelcomeOption.img" style="width: 100%; max-width: 250px" />
                </v-flex>
                <v-flex xs12 sm9 md8 class="px-4 py-3">
                  <div class="title primary--text mb-2">
                    {{ $t('You are now applying') }}
                    {{ $t('mode', { type: $t(currentWelcomeOption.text) }) }}
                  </div>
                  {{ $t(currentWelcomeOption.desc) }}
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </template>
        <template v-else>
          <v-layout wrap>
            <template v-for="option in welcometypeoptions">
              <v-flex xs12 sm6 md4 class="pa-1" :key="option.value">
                <v-card>
                  <v-card-text style="position: relative">
                    <v-premium-lock v-if="option.isPremium" class="ml-2"></v-premium-lock>
                    <v-radio-group
                      v-model="welcometype"
                      :disabled="
                        option.isPremium &&
                        !(
                          selectedBot.pagetype == 'enterprise' ||
                          $store.getters.getPackage == 'premium'
                        )
                      "
                      class="ma-0 mb-2"
                      hide-details
                    >
                      <v-radio :value="option.value" color="primary">
                        <template v-slot:label>
                          <div>
                            {{ $t(option.text) }}
                            <v-chip
                              v-if="option.isNew"
                              color="red"
                              small
                              disabled
                              class="white--text"
                              >{{ $t('New') }}</v-chip
                            >
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <div class="caption grey--text">{{ $t(option.desc) }}</div>
                    <img :src="option.img" style="width: 100%; max-width: 250px" class="mt-2" />
                  </v-card-text>
                </v-card>
              </v-flex>
            </template>
          </v-layout>

          <div class="text-xs-center" v-if="isEditWelcomeType">
            <v-btn color="grey" outline @click="onCancelWelcomeType">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" depressed @click="onSaveWelcomeType">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </v-container>

      <v-divider></v-divider>

      <template v-if="!isEditWelcomeType">
        <template v-if="welcometype == 'noreply'">
          <v-container style="max-width: 1000px">
            <div class="text-xs-center my-4"></div>
          </v-container>
        </template>
        <template v-else>
          <template v-if="welcometype == 'icebreaker'">
            <v-container style="max-width: 1000px">
              <ice-breaker v-model="icebreaker" @onSave="onSaveIcebreaker"></ice-breaker>
            </v-container>
            <v-divider></v-divider>
          </template>
          <v-container style="max-width: 1000px">
            <v-layout>
              <v-flex>
                <h3 class="headline" style="display: inline">{{ $t('Get Started') }}</h3>
                <v-modal-help>
                  <div slot="body">
                    <img class="responsive-img" src="/static/img/assets/help/h_choice.png" />
                    <div style="padding: 15px">
                      <p class="strong">สร้างคำตัวเลือก:</p>
                      <ol type="1" style="margin-bottom: 15px">
                        <li style="list-style: decimal">
                          กดปุ่ม “เพิ่มคำตัวเลือก” พิมพ์คำที่พบบ่อยเพื่อเป็นตัวเลือกให้ผู้ที่ทักมา
                          (จำกัดไม่เกิน 20 ตัวอักษรต่อหนึ่งคำตัวเลือก)
                        </li>
                      </ol>
                      <p>
                        ปล. “คำตัวเลือก” ที่สร้างไว้หน้านี้จะอยู่แค่ในหน้า ข้อความต้อนรับ (Welcome
                        Message) เท่านั้น หากไปหน้าอื่นคุณสามารถสร้างคำตัวเลือกในหน้านั่นๆได้ที่
                        “บทสนทนา (Conversation)”
                      </p>
                    </div>
                  </div>
                </v-modal-help>
              </v-flex>
              <v-flex class="text-xs-right">
                <v-btn
                  fab
                  outline
                  small
                  color="primary"
                  v-if="!isEditWelcome"
                  @click="isEditWelcome = !isEditWelcome"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <p>
              {{
                $t(
                  "Setting customers' sentence, keyword, and/or exact on the left handside and the bot's reply on the right."
                )
              }}
            </p>
            <template v-if="isWelcomeLoading">
              <scale-loader
                :color="$vuetify.theme.primary"
                height="45px"
                width="7px"
              ></scale-loader>
            </template>
            <template v-else>
              <template v-if="isEditWelcome">
                <manage-intent
                  :type="'edit'"
                  :isCommentToInbox="false"
                  v-model="welcome_intent"
                  @close="cancelEdit"
                  @saveIntent="saveWelcomeMessage"
                  :excludedIntentName="excludedIntentName"
                  :isWelcome="true"
                >
                  <div slot="welcome">
                    <intent-group v-model="messages" :isWelcome="true"></intent-group>
                  </div>

                  <div slot="footer" slot-scope="scope">
                    <div style="margin-bottom: 15px">
                      <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                        <i class="far fa-eye"></i>
                        {{ $t('preview') }}
                      </a>
                    </div>
                    <v-btn outline color="grey" @click="scope.cancelEdit">{{ $t('cancel') }}</v-btn>
                    <v-btn depressed color="primary" @click="scope.saveIntent">
                      {{ $t('Save') }}
                    </v-btn>
                  </div>
                </manage-intent>
              </template>
              <template v-else>
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pa-1">
                    <div class="question">
                      <p class="caption">{{ $t('customer says') }}</p>

                      <template v-if="normal && normal.length > 0">
                        <label class="caption">{{ $t('Sentence') }}</label>
                        <ul class="tags" style="margin-bottom: 5px">
                          <li
                            class="tag"
                            v-for="(question, index) in normal"
                            :key="'normal_question_' + index"
                            :class="{ disabled: !question.checkLang }"
                          >
                            <specialtext :text="question.text"></specialtext>
                            <i class="mark fas fa-exclamation-circle"></i>
                          </li>
                        </ul>
                      </template>
                      <template v-if="keyword && keyword.length > 0">
                        <label class="caption">{{ $t('Keyword') }}</label>
                        <ul class="tags" style="margin-bottom: 5px">
                          <li
                            class="tag"
                            v-for="(question, index) in keyword"
                            :key="'keyword_question_' + index"
                            :class="{ disabled: !question.checkLang }"
                          >
                            <specialtext :text="question.text"></specialtext>
                            <i class="mark fas fa-exclamation-circle"></i>
                          </li>
                        </ul>
                      </template>
                      <template v-if="exactly && exactly.length > 0">
                        <label class="caption">{{ $t('Exact word') }}</label>
                        <ul class="tags" style="margin-bottom: 5px">
                          <li
                            class="tag"
                            v-for="(question, index) in exactly"
                            :key="'exactly_question_' + index"
                            :class="{ disabled: !question.checkLang }"
                          >
                            <specialtext :text="question.text"></specialtext>
                            <i class="mark fas fa-exclamation-circle"></i>
                          </li>
                        </ul>
                      </template>
                      <template
                        v-if="
                          startwith &&
                          startwith.length > 0 &&
                          $store.getters.getPackage == 'premium'
                        "
                      >
                        <label class="caption">{{ $t('Start with') }}</label>
                        <ul class="tags" style="margin-bottom: 5px">
                          <li
                            class="tag"
                            v-for="(question, index) in startwith"
                            :key="'startwith_question_' + index"
                            :class="{ disabled: !question.checkLang }"
                          >
                            <specialtext :text="question.text"></specialtext>
                            <i class="mark fas fa-exclamation-circle"></i>
                          </li>
                        </ul>
                      </template>
                      <template
                        v-if="
                          endwith && endwith.length > 0 && $store.getters.getPackage == 'premium'
                        "
                      >
                        <label class="caption">{{ $t('End with') }}</label>
                        <ul class="tags" style="margin-bottom: 5px">
                          <li
                            class="tag"
                            v-for="(question, index) in endwith"
                            :key="'endwith_question_' + index"
                            :class="{ disabled: !question.checkLang }"
                          >
                            <specialtext :text="question.text"></specialtext>
                            <i class="mark fas fa-exclamation-circle"></i>
                          </li>
                        </ul>
                      </template>
                      <template
                        v-if="
                          startandendwith &&
                          startandendwith.length > 0 &&
                          $store.getters.getPackage == 'premium'
                        "
                      >
                        <label class="caption">{{ $t('Start and End with') }}</label>
                        <ul class="tags" style="margin-bottom: 5px">
                          <li
                            class="tag"
                            v-for="(question, index) in startandendwith"
                            :key="'startandendwith_question_' + index"
                            :class="{ disabled: !question.checkLang }"
                          >
                            <specialtext :text="question.text"></specialtext>
                            <i class="mark fas fa-exclamation-circle"></i>
                          </li>
                        </ul>
                      </template>

                      <label v-show="isOtherLang && $store.getters.getPackage != 'premium'">
                        <i class="fas fa-exclamation-circle"></i>
                        {{
                          $t(
                            'Basic Package supports only Thai and English languages. Other languages, please Upgrade to Premium'
                          )
                        }}
                      </label>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 class="pa-1">
                    <div class="answer">
                      <p class="caption">{{ $t('Chatbot answers') }}</p>
                      <message-viewer v-model="messages"></message-viewer>
                    </div>
                  </v-flex>

                  <v-flex xs12>
                    <template
                      v-if="
                        welcome_intent && (welcome_intent.context_in || welcome_intent.context_out)
                      "
                    >
                      <div class="hr" style="margin-top: 10px"></div>
                      <div class="row" style="margin-top: 15px; margin-bottom: 0px">
                        <div class="col s12 m6">
                          <p class="small">Context In</p>
                          <p>{{ welcome_intent.context_in ? welcome_intent.context_in : '-' }}</p>
                        </div>
                        <div class="col s12 m6">
                          <p class="small">Context Out</p>
                          <p>{{ welcome_intent.context_out ? welcome_intent.context_out : '-' }}</p>
                        </div>
                      </div>
                    </template>
                  </v-flex>
                </v-layout>
              </template>
            </template>
          </v-container>
          <v-divider></v-divider>
          <v-container style="max-width: 1000px">
            <v-layout>
              <v-flex>
                <h3 class="headline" style="display: inline">{{ $t('Choice') }}</h3>
                <v-modal-help>
                  <div slot="body">
                    <img class="responsive-img" src="/static/img/assets/help/h_choice.png" />
                    <div style="padding: 15px">
                      <p class="strong">สร้างคำตัวเลือก:</p>
                      <ol type="1" style="margin-bottom: 15px">
                        <li style="list-style: decimal">
                          กดปุ่ม “เพิ่มคำตัวเลือก” พิมพ์คำที่พบบ่อยเพื่อเป็นตัวเลือกให้ผู้ที่ทักมา
                          (จำกัดไม่เกิน 20 ตัวอักษรต่อหนึ่งคำตัวเลือก)
                        </li>
                      </ol>
                      <p>
                        ปล. “คำตัวเลือก” ที่สร้างไว้หน้านี้จะอยู่แค่ในหน้า ข้อความต้อนรับ (Welcome
                        Message) เท่านั้น หากไปหน้าอื่นคุณสามารถสร้างคำตัวเลือกในหน้านั่นๆได้ที่
                        “บทสนทนา (Conversation)”
                      </p>
                    </div>
                  </div>
                </v-modal-help>
              </v-flex>
              <v-flex class="text-xs-right">
                <v-btn
                  fab
                  outline
                  small
                  color="primary"
                  v-if="!isEditChoice"
                  @click="isEditChoice = !isEditChoice"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>

            <span class="small">
              {{ $t('Options for customers to quickly reply (Not exceed 20 alphabets)') }}
            </span>
            <quick-reply
              v-model="welcome_quickreplies"
              :isEdit="isEditChoice"
              @onSave="isEditChoice = false"
              @onChangeChoice="onChangeChoice"
            >
              <div slot="footer" slot-scope="scope">
                <div style="margin-bottom: 15px">
                  <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                    <i class="far fa-eye"></i>
                    {{ $t('preview') }}
                  </a>
                </div>
                <div>
                  <v-btn outline color="grey" @click="scope.cancelEdit">{{ $t('cancel') }}</v-btn>
                  <v-btn depressed color="primary" @click="scope.saveContent">
                    {{ $t('Save') }}
                  </v-btn>
                </div>
              </div>
            </quick-reply>
          </v-container>
          <v-divider></v-divider>
          <template v-if="welcometype == 'getstarted'">
            <v-container style="max-width: 1000px">
              <v-layout>
                <v-flex>
                  <h3 class="headline" style="display: inline">{{ $t('Extra Menu') }}</h3>
                  <v-modal-help>
                    <div slot="body">
                      <img
                        class="responsive-img"
                        src="/static/img/assets/help/h_persistent_menu.png"
                      />
                      <div style="padding: 15px">
                        <p class="strong">“ตัวอย่างเมนูเสริมเมื่อใช้งานจริง” (รูปด้านบน)</p>
                        <p>มีการตั้งค่าปุ่มกด 2 ปุ่ม</p>
                        <p>
                          <span class="strong">ปุ่มแรก: Main Menu</span> เลือกรูปแบบการตอบกลับแบบ
                          TEXT (ข้อความ) ซึ่งเมื่อสร้างเสร็จจะต้องไปตั้งค่าหน้า “ตั้งค่าบทสนทนา
                          (Conversation)” ว่าถ้ามีคนคลิกปุ่ม “Main Menu” จะให้ Bot ตอบกลับว่าอย่างไร
                        </p>
                        <p>
                          <span class="strong">ปุ่มที่สอง: Website</span> เลือกรูปแบบการตอบกลับแบบ
                          LINK (ลิ้งค์), กรณีนี้เพียงแค่เราใส่ website ลงไปก็ถือเป็นอันเสร็จสิ้น
                          เมื่อมีคนกดปุ่มนี้ ระบบจะนำพาผู้กดเข้าไปยังเว็บไซต์ที่เรากำหนดเลยทันที
                        </p>
                      </div>
                    </div>
                  </v-modal-help>
                </v-flex>
                <v-flex class="text-xs-right">
                  <template
                    v-if="
                      selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                    "
                  >
                    <v-btn
                      small
                      color="info"
                      :to="'/' + $i18n.locale() + '/upgrade'"
                      class="white--text"
                    >
                      <v-icon class="mr-2" small>lock</v-icon>
                      {{ $t('Upgrade to Premium Plan') }}
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn
                      fab
                      outline
                      small
                      color="primary"
                      v-if="!isEditExtraMenu"
                      @click="isEditExtraMenu = !isEditExtraMenu"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                </v-flex>
              </v-layout>
              <p>{{ $t('Shortcut side bar') }}</p>
              <persistent-menu
                v-model="persistent_menu"
                :isEdit="isEditExtraMenu"
                @onSave="isEditExtraMenu = false"
              ></persistent-menu>
            </v-container>
          </template>
        </template>
      </template>

      <preview-message
        v-if="showPreview"
        @close="showPreview = false"
        :messages="messages"
        :choice="previewChoices"
        :questions="questions"
      ></preview-message>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

import specialtext from '@/components/elements/specialtext'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import QuickReply from '@/components/view/chatbot/QuickReply'

import IntentGroup from '@/components/view/intent/IntentGroup'
import ManageIntent from '@/components/view/intent/intent-manage'

import PersistentMenu from '@/components/view/setting/PersistentMenu'
import PreviewMessage from '@/components/elements/PreviewMessage'
import FacebookScreen from '@/components/elements/FacebookScreen'

import IceBreaker from './IceBreaker'

export default {
  data: function () {
    return {
      isEditWelcomeType: false,
      welcometypeoptions: [
        {
          text: 'Get Started',
          value: 'getstarted',
          isNew: false,
          isPremium: false,
          img: '/static/img/assets/welcome/1_getstart.jpg',
          desc: 'Once clicking Get Started button, a welcome message appears to reply users.',
        },
        {
          text: 'Multiple greeting choices',
          value: 'icebreaker',
          isNew: true,
          isPremium: true,
          img: '/static/img/assets/welcome/2_icebreaker.jpg',
          desc:
            'Selecting messages can be determined to display as buttons on welcome message, which allows to create a maximum of 5 buttons.',
        },
        {
          text: 'No Reply',
          value: 'noreply',
          isNew: true,
          isPremium: true,
          img: '/static/img/assets/welcome/3_noreply.jpg',
          desc:
            'Once using No Reply mode, a bot may not at first send a welcome message and an extra menu will no longer be shown.',
        },
      ],
      welcometype: 'getstarted',
      isIceBreakerEdit: false,
      isEditWelcome: false,
      isEditExtraMenu: false,
      isEditChoice: false,
      showPreview: false,
      isWelcomeLoading: false,
      messages: [[]],
      message: null,
      excludedIntentName: '',
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true,
        },
      ],
      type: 'json',

      showEmoji: false,

      welcome_quickreplies: undefined,
      persistent_menu: undefined,
      welcome_intent: undefined,
      previewChoices: [],
      normal: [],
      keyword: [],
      exactly: [],
      startwith: [],
      endwith: [],
      startandendwith: [],
      isOtherLang: false,

      icebreaker: [],
    }
  },
  components: {
    GenericViewer,
    MessageViewer,
    QuickReply,
    PersistentMenu,
    IntentGroup,
    ManageIntent,
    specialtext,
    PreviewMessage,
    ScaleLoader,
    FacebookScreen,
    IceBreaker,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct',
      loadingSetting: 'getLoadingSetting',
      contents: 'getSetting',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory',
    }),
    currentWelcomeOption() {
      var option = this.welcometypeoptions.find((el) => {
        return el.value == this.welcometype
      })
      return option
    },
    pageid: function () {
      if (!this.$store.state.selectedBot) {
        return null
      }
      return this.$store.state.selectedBot.pageid
    },
    replies: function () {
      var vm = this
      if (
        vm.welcome_quickreplies &&
        vm.welcome_quickreplies.contentvalue &&
        vm.welcome_quickreplies.contentvalue != null &&
        vm.welcome_quickreplies.contentvalue != ''
      ) {
        var tags = vm.welcome_quickreplies.contentvalue.split(',')
        var result = []
        $.each(tags, function (index, val) {
          result.push({ text: val })
        })
        return result
      } else {
        return []
      }
    },

    questions: function () {
      if (this.welcome_intent && this.welcome_intent.q_val != '') {
        return this.welcome_intent.q_val.split(',')
      } else {
        return []
      }
    },
    answers: function () {
      return [[]]
    },
  },

  created: async function () {
    var vm = this
    this.getLineNotify()
    if (['ecommercebasic', 'ticket', 'nvbb'].includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting').then(function () {
      if (vm.contents.welcome_quickreplies) {
        vm.welcome_quickreplies = vm.contents.welcome_quickreplies
      }
    })

    vm.isWelcomeLoading = true
    vm.getIntent(function () {
      vm.getWelcomeMessage(function (status) {
        if (status) {
          vm.cached_message = vm.message
          vm.cached_generics = []
          vm.cached_messages = []
          $.each(vm.generics, function (index, generic) {
            vm.cached_generics[index] = Object.assign({}, generic)
            vm.cached_generics[index].buttons = []
            $.each(generic.buttons, function (bindex, button) {
              vm.cached_generics[index].buttons[bindex] = Object.assign({}, button)
            })
          })

          vm.cached_messages = JSON.stringify(vm.messages)

          vm.cached_type = vm.type

          vm.isWelcomeLoading = false
        }
      })
    })

    var response = await vm.getgetstartedmenu()
    if (response.data && response.data.length > 0) {
      var welcometype = response.data[0]
      if (welcometype.ice_breakers) {
        this.welcometype = 'icebreaker'
        this.icebreaker = welcometype.ice_breakers
      } else if (welcometype.get_started) {
        this.welcometype = 'getstarted'
      }
    } else {
      this.welcometype = 'noreply'
    }

    this.cached_welcometype = this.welcometype

    // vm.getPersistentMenu(function() {});
  },
  methods: {
    getgetstartedmenu() {
      var data = {
        pageid: this.selectedBot.pageid,
        access_token: this.selectedBot.page_access_token,
        status: this.selectedBot.status,
        premium:
          this.selectedBot.pagetype == 'enterprise' || this.$store.getters.getPackage == 'premium',
      }
      return new Promise((resolve, reject) => {
        api.getgetstartedmenu(data, function (error, response) {
          if (error) {
            reject(error)
            return
          }

          resolve(response)
        })
      })
    },
    savegetstartedmenu(data) {
      return new Promise((resolve, reject) => {
        api.savegetstartedmenu(data, function (error, response) {
          if (error) {
            reject(error)
            return
          }

          resolve(response)
        })
      })
    },
    async onSaveIcebreaker() {
      var data = {
        access_token: this.selectedBot.page_access_token,
        pageid: this.selectedBot.pageid,
        status: true,
        getstarted_menu: {
          get_started: {
            payload: 'menu',
          },
        },
      }
      data.getstarted_menu = {
        ice_breakers: this.icebreaker,
      }
      await this.savegetstartedmenu(data)
    },
    onCancelWelcomeType() {
      this.isEditWelcomeType = false
      this.welcometype = this.cached_welcometype
    },
    async onSaveWelcomeType() {
      var result = await this.$swal.fire({
        title: this.$t('Changing the welcome message mode'),
        text: this.$t(
          'Changing a welcome message mode may cause your previous setting to change or be deleted. Do you want to continue?'
        ),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true,
      })

      if (result.value) {
        this.isEditWelcomeType = false
        var data = {
          access_token: this.selectedBot.page_access_token,
          pageid: this.selectedBot.pageid,
          status: true,
          getstarted_menu: {
            get_started: {
              payload: 'menu',
            },
          },
        }
        if (this.welcometype == 'getstarted') {
          data.getstarted_menu = {
            get_started: {
              payload: 'menu',
            },
          }
        } else if (this.welcometype == 'icebreaker') {
          if (this.icebreaker && this.icebreaker.length == 0) {
            this.icebreaker.push(
              {
                question: 'เมนูหลัก',
                payload: 'เมนูหลัก',
              },
              {
                question: 'ติดต่อแอดมิน',
                payload: 'ติดต่อแอดมิน',
              }
            )
          }
          data.getstarted_menu = {
            ice_breakers: this.icebreaker,
          }
        } else if (this.welcometype == 'noreply') {
          data.getstarted_menu = null
        }
        await this.savegetstartedmenu(data)

        this.cached_welcometype = this.welcometype
      }
    },
    onScroll() {},

    formatData: function (text) {
      var vm = this
      var questions = text && text !== '' ? text.split(',') : []
      var isPremium = vm.$store.getters.getPackage === 'premium'
      vm.normal = []
      vm.keyword = []
      vm.exactly = []
      vm.startwith = []
      vm.endwith = []
      vm.startandendwith = []
      if (questions) {
        questions.map(function (question, index) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium),
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.endwith.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startandendwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium),
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.keyword.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.exactly.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium),
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else {
            vm.normal.push({ text: question, checkLang: vm.isSupportLanguage(question, isPremium) })
            if (!vm.isSupportLanguage(question, isPremium)) {
              vm.isOtherLang = true
            }
          }
        })
      }
    },
    onChangeChoice: function (payload) {
      this.previewChoices = payload
    },
    onOptionChange: function (option) {
      this.type = option
      // this.saveWelcomeMessage()
    },
    getLineNotify: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineNotify({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.linenotifylist) {
            vm.$store.state.linenotifylist = response.linenotifylist
          }
          resolve()
        })
      })
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      if (!vm.selectedBot) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid,
      }

      vm.message = null
      vm.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true,
        },
      ]
      vm.type = 'json'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          callback(false)
          return
        }
        if (response.data) {
          if (response.data.type != 'json') {
            if (response.data.type == 'message') {
              if (response.data.message_text == '') {
                vm.messages = [[]]
              } else {
                var group = []
                var group_messages = response.data.message_text.split('||')
                $.each(group_messages, function (index, messages) {
                  var messages = messages.split('#nl')
                  var newMessages = []
                  $.each(messages, function (inedx, message) {
                    console.log(message, vm.isURL(message))
                    if (vm.isURL(message)) {
                      newMessages.push({
                        type: 'image',
                        image_url: message,
                      })
                    } else if (!isNaN(message)) {
                      newMessages.push({
                        type: 'text',
                        text: message,
                      })
                    } else if (vm.isJsonParseable(message)) {
                      var parsedMessage = JSON.parse(message)
                      newMessages.push({
                        type: 'button',
                        text: parsedMessage.text,
                        buttons: parsedMessage.buttons,
                      })
                    } else if (message == '') {
                    } else {
                      newMessages.push({
                        type: 'text',
                        text: message,
                      })
                    }
                  })
                  group.push(newMessages)
                })

                vm.messages = group
              }
            } else if (response.data.type == 'generic') {
              vm.messages[0][0] = {
                type: 'generic',
                data: response.data.message,
                ratio: response.ratio == 'horizontal' ? 'horizontal' : 'square',
              }
            }
          } else {
            vm.messages = JSON.parse(response.data.message)
          }
          vm.type = 'json'
        }
        callback(true)
      })
    },
    getPersistentMenu: function (callback) {
      var vm = this

      if (
        this.selectedBot.pagetype != 'enterprise' &&
        this.$store.getters.getPackage != 'premium'
      ) {
        vm.persistent_menu = [
          {
            title: 'Powered By ZWIZI.AI',
            type: 'web_url',
            url: 'https://zwiz.ai/en',
            webview_height_ratio: 'compact',
          },
        ]
      } else {
        var url =
          'https://graph.facebook.com/me/messenger_profile?fields=persistent_menu&access_token=' +
          vm.$store.state.selectedBot.page_access_token
        axios.get(url).then((response) => {
          if (response.status == 200) {
            var response = response.data
            if (
              response.data[0] &&
              response.data[0]['persistent_menu'] &&
              response.data[0]['persistent_menu'][0] &&
              response.data[0]['persistent_menu'][0]['call_to_actions']
            ) {
              vm.persistent_menu = response.data[0]['persistent_menu'][0]['call_to_actions']
              callback()
            }
          }
        })
      }
    },
    addGeneric: function () {
      if (this.generics.length < 10) {
        this.generics.push({
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true,
        })
      }
    },
    onDeleteGeneric: function (index) {
      if (this.generics.length > 1) {
        this.generics.splice(index, 1)
      } else {
        alert('Welcome Message cannot be less than 1')
      }
    },
    saveWelcomeMessage: function () {
      let vm = this
      let data = {
        pageid: vm.$store.state.selectedBot.pageid,
        type: 'json',
      }

      vm.$store.dispatch('loading')
      var messages = []
      $.each(vm.messages, function (index, message) {
        var group = []
        $.each(message, function (mindex, msg) {
          if (msg.type == 'text') {
            if (msg.text != '' && msg.text != null) {
              group.push(msg)
            }
          } else if (msg.type == 'button') {
            if ((msg.text != '' && msg.text != null) || msg.buttons.length > 0) {
              group.push(msg)
            }
          } else if (msg.type == 'image') {
            if (msg.image_url) {
              group.push(msg)
            }
          } else if (msg.type == 'generic') {
            var generics = []
            $.each(msg.data, function (gindex, generic) {
              if (
                generic.image_url != null ||
                generic.title != '' ||
                generic.subtitle != '' ||
                generic.buttons.length > 0
              ) {
                generics.push(generic)
              }
            })
            if (generics.length > 0) {
              group.push({
                type: 'generic',
                data: generics,
                ratio: msg.ratio == 'horizontal' ? 'horizontal' : 'square',
              })
            }
          } else {
            group.push(msg)
          }
        })
        if (group.length > 0) {
          messages.push(group)
        }
      })

      if (messages.length == 0) {
        messages = [[]]
      }

      data['message'] = JSON.stringify(messages)

      api.saveWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        // console.log(data)
        vm.cached_type = vm.type
        vm.cached_messages = JSON.stringify(messages)
        vm.messages = messages
        vm.$store.dispatch('updateWelcomeMessage', {
          type: 'json',
          message: null,
          generics: null,
          messages: messages,
        })

        vm.isEditWelcome = false
        vm.$store.dispatch('loading')
      })
    },
    cancelEdit: function () {
      var vm = this
      this.message = this.cached_message
      vm.generics = []
      $.each(vm.cached_generics, function (index, generic) {
        vm.generics[index] = Object.assign({}, generic)
        vm.generics[index].buttons = []
        $.each(generic.buttons, function (bindex, button) {
          vm.generics[index].buttons[bindex] = Object.assign({}, button)
        })
      })
      vm.messages = JSON.parse(vm.cached_messages)

      vm.type = vm.cached_type
      vm.isEditWelcome = false
    },
    saveContent: function () {
      var vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          vm.goToErrorInput()
          // do stuff if not valid.
          // console.log(this.$validator.errors.items)
          return false
        }
        vm.saveWelcomeMessage()
        if (vm.type == 'message') {
          vm.cached_message = vm.message
        } else if (vm.type == 'generic') {
          vm.cached_generics = []
          $.each(vm.generics, function (index, generic) {
            vm.cached_generics[index] = Object.assign({}, generic)
            vm.cached_generics[index].buttons = []
            $.each(generic.buttons, function (bindex, button) {
              vm.cached_generics[index].buttons[bindex] = Object.assign({}, button)
            })
          })
        } else if (vm.type == 'json') {
          vm.cached_messages = JSON.stringify(vm.messages)
        }
        vm.isEditWelcome = false
      })
    },
    addEmoji: function (emoji) {
      this.message += emoji.native
      this.showEmoji = false
    },
    checkMove: function (event) {},
    onMove: function (index, direction) {
      var vm = this
      if (direction == 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction == 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    getIntent: function (callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid,
      }
      api.getIntent(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundWelcome = false
          $.each(response.data, function (index, val) {
            var intent = val
            intent.isShow = false
            if (intent.intentname == '{welcome}') {
              isFoundWelcome = true
              intent.ableToDelete = false
              vm.welcome_intent = intent
            }
          })

          if (!isFoundWelcome) {
            vm.welcome_intent = {
              intentname: '{welcome}',
              q_type: 'text',
              a_type: 'json',
              q_val: '',
              a_val: [[]],
              context_in: '',
              context_out: '',
              ableToDelete: false,
              isShow: false,
            }
          }
        }
        callback()
      })
    },
  },
  watch: {
    selectedBot: function (newVal, oldVal) {
      this.getWelcomeMessage(function () {})
    },
    welcome_intent: {
      handler: function (newVal) {
        this.formatData(this.welcome_intent.q_val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/welcomemessage/WelcomeMessage.vue